import { render, staticRenderFns } from "./vimeo-player.vue?vue&type=template&id=1d70b663&scoped=true&"
import script from "./vimeo-player.vue?vue&type=script&lang=js&"
export * from "./vimeo-player.vue?vue&type=script&lang=js&"
import style0 from "./vimeo-player.vue?vue&type=style&index=0&id=1d70b663&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d70b663",
  null
  
)

export default component.exports